import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';

export default class ChoosePoint extends Component {
  constructor(props) {
    super(props);
    console.log('new location init', this.props);
    this.choosePosition = this.choosePosition.bind(this);
    this.state = {
      latitude: this.props.data.latitude,
      longitude: this.props.data.longitude,
      locked: this.props.data.locked
    };
  }
  choosePosition() {
    console.log('Choose position');
    this.setState({
      latitude: sessionStorage.getItem("latitude"),
      longitude: sessionStorage.getItem("longitude"),
      locked: true
    }, () => {
      console.log('postion is set i think', this.state);
      this.props.onLocationChange(this.state);
    });
  }
  render() {


    console.log('new-location renders', this.state, this.props);
    return (
      <Fragment>
        <main id="new-post">
          <h1>Location for the post</h1>
          <p>Center the map to the desired location.</p>
          { this.state.locked ? <p>Post is located at { this.props.data.latitude }, { this.props.data.longitude }.</p> : <p>Lock position to continue</p> }
          <button onClick={ this.choosePosition }>Lock position</button>
          { this.state.locked ? <Link to="/add/post">Add post</Link> : false }
        </main>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/view/new-location.jsx